import { render, staticRenderFns } from "./setting_page.vue?vue&type=template&id=666dd8cb&scoped=true"
import script from "./setting_page.vue?vue&type=script&lang=js"
export * from "./setting_page.vue?vue&type=script&lang=js"
import style0 from "./setting_page.vue?vue&type=style&index=0&id=666dd8cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666dd8cb",
  null
  
)

export default component.exports